import { ChevronRight, StarRounded } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import React from 'react';
import { theme } from '../../../theme';
import OverdueChip from '../../CampaignMonitoring/OverdueChip';
import { useNavigate } from 'react-router';

function CardEntry(props) {
    const navigate = useNavigate();

    function handleNavigate() {
        if (props.variant === 'clinical') {
            navigate(`/staffReview/${props.draft.id}`);
        } else {
            navigate(`/implementerInbox/${props.draft.id}`);
        }
    }

    return (
        <Stack 
            direction='row'
            alignItems='center' 
            justifyContent='space-between'
            onClick={handleNavigate}
            p={2}
            style={{
                cursor: 'pointer'
            }}
        >
            <Stack direction='row' alignItems='center' spacing={1} sx={{ flex: 1, minWidth: 0 }}>
                { props.isTopDraft && <StarRounded style={{ color: theme.palette.primary.main }} /> }
                <Typography 
                    variant='normal' 
                    fontSize='16px' 
                    sx={{ 
                        overflowWrap: 'break-word',
                        flex: 1,
                        minWidth: 0
                    }}
                >
                    {props.draft.card.name}
                </Typography>
                { props.draft.num_overdue_reviews > 0 &&
                    <OverdueChip format='staff_review_count' numOverdue={props.draft.num_overdue_reviews} />
                }
            </Stack>
            <Stack direction='row' spacing={1} alignItems='center' sx={{ flexShrink: 0, whiteSpace: 'nowrap', marginLeft: 2 }}>
                { (props.draft.status === 'review' || props.draft.status === 'submitted' || (props.draft.status === 'applied' && props.variant === 'implementer')) && 
                    <>
                        { props.draft.num_recommendations_to_review > 0 ? (
                            <>
                                <Typography color={theme.palette.blue.main} variant='normal' fontSize='16px'>{props.draft.num_recommendations_to_review} Request{props.draft.num_recommendations_to_review !== 1 && 's'} to Review</Typography>
                                <ChevronRight style={{ color: theme.palette.blue.main }} />
                            </>
                        ) : (
                            <>
                                <Typography color={theme.palette.blue.main} variant='normal' fontSize='16px'>Ready to Submit</Typography>
                                <ChevronRight style={{ color: theme.palette.blue.main }} />
                            </>
                        )}
                    </>
                }
                { ((props.variant === 'clinical' && props.draft.status === 'applied') || (props.variant === 'implementer' && props.draft.status === 'implemented')) && props.draft.num_recommendations_to_review &&
                    <>
                        <Typography color='black' variant='normal' fontSize='16px'>{props.draft.num_recommendations_to_review} Request{props.draft.num_recommendations_to_review !== 1 && 's'} Reviewed</Typography>
                        <ChevronRight />
                    </>
                }
            </Stack>
        </Stack>
    );
}

export default CardEntry;
